import { queryClient } from 'index';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { LogyxError } from 'services/api/errors';
import { getToastErrorMessage } from 'services/api/errors';
import { useTranslation } from 'react-i18next';
import { addCompanyUser } from 'services/CompanyService';

export interface IAddUserDTO {
  email: string;
}

export const useAddUser = () => {
  const { t } = useTranslation();
  return useMutation((dto: IAddUserDTO) => addCompanyUser(dto.email), {
    onSuccess: () => {
      toast.success(t('Successfully added user'));
      queryClient.invalidateQueries([ReactQueryKeys.GET_USERS]);
    },
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error), {
        toastId: ReactMutationKeys.ADD_COMPANY_USER,
      });
    },
    mutationKey: ReactMutationKeys.ADD_COMPANY_USER,
  });
};
